// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Select from '../../CustomSelect';
import CustomValueContainer from '../../customSelectElements/ValueContainerForMultiSelect';
import CustomMultiValueLabel from '../../customSelectElements/MultiValueLabelShort';
import Loader from '../../../dashboard/common/Loader';
import ToolsElement from './ToolsElement';
import CustomOption from '../../customSelectElements/CustomSelectOptionElement';
import Notification from '../../../notification';
import { white as customSelectStyle } from '../../../../utils/customSelectStyle';

const SelectWorkOrderWorkTypes = ({
  value, onChange, toolsElementClass, deleteElementIconColor,
}) => {
  const [tools, setTools] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    axios.get('/api/users/fetch_tools_detail')
      .then((res) => {
        setTools(res.data.tools.map((item) => ({
          label: item.title,
          // eslint-disable-next-line no-underscore-dangle
          value: item._id,
          item,
        })));
        setIsLoading(false);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('error', error);
        Notification('error', { message: error.response?.data?.message || error.message });
        setIsLoading(false);
      });
  }, []);

  const deleteWorkType = (index) => {
    const newSelected = value.filter((item, i) => index !== i);
    onChange(newSelected);
  };

  return isLoading
    ? <Loader />
    : (
      <div className="fields_group border-bottom-line">
        <div className="field_col" style={{ maxWidth: '400px' }}>
          <Select
            isClearable
            isSearchable
            isMulti
            components={{
              ValueContainer: CustomValueContainer,
              MultiValueLabel: CustomMultiValueLabel,
              Option: CustomOption,
            }}
            closeMenuOnSelect
            hideSelectedOptions={false}
            options={tools}
            styles={{
              ...customSelectStyle,
              menuList: (provided) => ({
                ...provided,
                position: 'unset',
              }),
            }}
            onChange={onChange}
            value={Array.isArray(value) ? value : []}
            placeholder="Choose Work Type"
          />
        </div>
        <div className="field_col">
          <div className="selected_tools flex-box font12">
            {
              value && value.map((item, i) => (
                <ToolsElement
                  key={item.value ?? `work-type-${i}`}
                  label={item.label ?? item.title ?? ''}
                  deleteTools={() => deleteWorkType(i)}
                  className={toolsElementClass}
                  deleteIconColor={deleteElementIconColor}
                />
              ))
            }
          </div>
        </div>
      </div>
    );
};

export default SelectWorkOrderWorkTypes;
